export default __webpack_public_path__ + "static/media/Ficha_Pegada-2.da3c1587.png";